import { EmptyBox } from 'components'
import { Table, Card, Checkbox } from 'semantic-ui-react'
import React from 'react'
import styled from 'styled-components'
import { PaginationComponent } from 'components/Pagination'
import { DesktopMode, MobileMode } from 'layout'
import { DateUtility, DateFormat } from 'utility'
import { AppPrimaryButton } from 'elements'

const TableConatiner = styled.div`
    .label {
        a {
            opacity: 1;
        }
    }
`

const orderBadgeStyle = {
    fontSize: '0.75rem',
    background: '#e1e7ff',
    color: '#324a8a',
    borderRadius: '3px',
    padding: '2px 6px',
    marginLeft: '8px',
    display: 'inline-block',
}

const CombineTemplateRow = ({ item, isSelected, selectedOrder, onSelect }) => {
    const auditId = item.TaskId || item.AuditUniqueId
    return (
        <Table.Row>
            <Table.Cell textAlign="center">
                <Checkbox
                    checked={isSelected}
                    onChange={() => onSelect(auditId)}
                />
            </Table.Cell>
            <Table.Cell textAlign="center">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <p style={{ margin: 0 }}>{item?.AuditName || '-'}</p>
                    {isSelected && selectedOrder && (
                        <span style={orderBadgeStyle}>{selectedOrder}</span>
                    )}
                </div>
            </Table.Cell>
            <Table.Cell textAlign="center">
                {item?.CompletedOn
                    ? DateUtility.dateToLocalISO(
                          new Date(item.CompletedOn),
                          DateFormat.dateTime,
                      )
                    : '-'}
            </Table.Cell>
        </Table.Row>
    )
}

const CombineTemplateCard = ({ item, isSelected, selectedOrder, onSelect }) => {
    const auditId = item.TaskId || item.AuditUniqueId
    return (
        <Card fluid className="mb-3">
            <Card.Content>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Card.Header className="mb-0">
                            {item?.AuditName || '-'}
                        </Card.Header>
                        {isSelected && selectedOrder && (
                            <span style={orderBadgeStyle}>{selectedOrder}</span>
                        )}
                    </div>
                    <Checkbox
                        checked={isSelected}
                        onChange={() => onSelect(auditId)}
                        label="Combine Template"
                    />
                </div>
                <Card.Meta>
                    <div>
                        <b>Completed On:</b>{' '}
                        {item?.CompletedOn
                            ? DateUtility.dateToLocalISO(
                                  new Date(item.CompletedOn),
                                  DateFormat.dateTime,
                              )
                            : '-'}
                    </div>
                </Card.Meta>
            </Card.Content>
        </Card>
    )
}

export const CombineTemplateDataTable = ({
    data,
    loading,
    pagination,
    pageChanged,
    selectedItems,
    onSelectItem,
    onCombineReport,
    merging,
}) => {
    return (
        <TableConatiner>
            <DesktopMode>
                <Table celled>
                    <Table.Header>
                        <Table.Row active>
                            <Table.HeaderCell textAlign="center">
                                Combine Template
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">
                                Audit Name
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">
                                Completed On
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {data?.map(item => {
                            const auditId = item.TaskId || item.AuditUniqueId
                            const selectedItem = selectedItems.find(si => si.auditId === auditId)
                            const isSelected = !!selectedItem
                            const selectedOrder = selectedItem?.order
                            return (
                                <React.Fragment key={auditId}>
                                    <CombineTemplateRow
                                        item={item}
                                        isSelected={isSelected}
                                        selectedOrder={selectedOrder}
                                        onSelect={onSelectItem}
                                    />
                                </React.Fragment>
                            )
                        })}
                    </Table.Body>
                </Table>
                {!!data?.length && !loading && selectedItems.length >= 2 && (
                    <div className="w-100 d-flex justify-content-end mt-3">
                        {onCombineReport && (
                            <AppPrimaryButton
                                type="button"
                                onClick={onCombineReport}
                                loading={merging}
                                disabled={merging}
                            >
                                Combine Report
                            </AppPrimaryButton>
                        )}
                    </div>
                )}
                {!!data?.length && !loading && (
                    <div className="w-100 justify-content-end d-flex mt-3">
                        <PaginationComponent
                            activePage={pagination.currentPage}
                            pageChanged={pageChanged}
                            pageSize={pagination.perPage}
                            totalCount={pagination.total}
                        />
                    </div>
                )}
                {(!data || !data.length) && !loading && <EmptyBox />}
            </DesktopMode>
            <MobileMode>
                {data?.length
                    ? data.map(item => {
                          const auditId = item.TaskId || item.AuditUniqueId
                          const selectedItem = selectedItems.find(si => si.auditId === auditId)
                          const isSelected = !!selectedItem
                          const selectedOrder = selectedItem?.order
                          return (
                              <CombineTemplateCard
                                  key={auditId}
                                  item={item}
                                  isSelected={isSelected}
                                  selectedOrder={selectedOrder}
                                  onSelect={onSelectItem}
                              />
                          )
                      })
                    : !loading && <EmptyBox />}
                {!!data?.length && !loading && selectedItems.length >= 2 && (
                    <div className="w-100 d-flex justify-content-end mt-3">
                        {onCombineReport && (
                            <AppPrimaryButton
                                type="button"
                                onClick={onCombineReport}
                                loading={merging}
                                disabled={merging}
                            >
                                Combine Report
                            </AppPrimaryButton>
                        )}
                    </div>
                )}
                {!!data?.length && !loading && (
                    <div className="w-100 justify-content-end d-flex mt-3">
                        <PaginationComponent
                            activePage={pagination.currentPage}
                            pageChanged={pageChanged}
                            pageSize={pagination.perPage}
                            totalCount={pagination.total}
                        />
                    </div>
                )}
            </MobileMode>
        </TableConatiner>
    )
}
